import React, { useEffect, useState } from 'react';
import { Api, pathJoin } from '../../../services/api';
import { useHasPermission } from '../../../services/auth/auth';
import { LoadText } from '../load/loadText';
import { HeadingCard } from '../cards/headingCard';
import { useFeatureContext } from '../../feature/featureContext';
import { ErrorPage } from '../error/errorPage';
import { ActionButtonModes } from '../actions/actionButtons';
import { record } from '../../../services/history';
import { iconMap } from '../../../services/routing/routes';

import styles from './view.module.css';

export const View = ({
    id,
    resourceName,
    nameFunction,
    children,
    readPermissions,
    writePermissions,
    restEndpoint,
    refreshToken,
    listUrl,
    actions = []
}) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    /** @type [string, function(string): void] */
    // @ts-ignore
    const [error, setError] = useState(null);
    const [name, setName] = useState('');

    const canRead = useHasPermission(readPermissions);
    const canWrite = useHasPermission(writePermissions);

    const { setFeatureContext } = useFeatureContext();

    useEffect(() => {
        getData();
    }, [id, refreshToken]);

    useEffect(() => {
        setName(nameFunction(data));
    }, [data]);

    const getData = async () => {

        if (Number.isNaN(id) || !id) return;

        setLoading(true);
        setFeatureContext({
            id: id,
            loading: true
        });

        await Api.get(pathJoin(restEndpoint, id)) 
        .then(json => {
            if (!json.content || json.content.length === 0)
                setError(`It looks like this ${resourceName.toLowerCase()} doesn\'t exist.`)
            else {
                setData(json.content[0]);

                record(resourceName, id, nameFunction(json.content[0]), pathJoin(listUrl, id));

                setFeatureContext({
                    id: id,
                    loading: false,
                    name: nameFunction(json.content[0]),
                });
            }

            setLoading(false);
        })
        .catch(e => {
            console.error(`Unable to get ${resourceName.toLowerCase()} data`, e);

            setError(`There was an issue getting the data for this ${resourceName.toLowerCase()}.`)

            setLoading(false);
            setFeatureContext({
                id: id,
                loading: false,
            });
        });
    }

    const refreshData = async () => {
        getData();
    }

    return (<>
    {
        (error) ?
        <ErrorPage>{error}</ErrorPage>
        :
        <div className={styles.View}>
            <header>
                <HeadingCard subtitle={resourceName} Icon={iconMap[resourceName]}>
                    {loading ? <LoadText dark={false} max={50} strength={2} /> : nameFunction(data)}
                </HeadingCard>
                <div className={styles.Actions}>
                    {/* <Button onClick={() => getData()}>Reload</Button> */}
                    {
                        actions.map((Action, i) => <Action
                            key={Action.toString() + i.toString()}
                            name={name}
                            data={[data]}
                            ids={[id]}
                            resourceName={resourceName}
                            restEndpoint={restEndpoint}
                            setSelected={() => {}}
                            refreshData={refreshData}
                            nameFunction={nameFunction}
                            mode={ActionButtonModes.View}
                            canRead={canRead}
                            canWrite={canWrite}
                            listUrl={listUrl}
                        />)
                    }
                </div>
            </header>

            <div className='view-grid'>
               {children({ loading, data, canRead, canWrite, refreshData })}
            </div>
        </div>
    }
    </>)
}